module.exports = __webpack_public_path__ + "static/media/Charlottesville.c4a88f10.png";